import React from 'react'

import { useAppSelector } from '@app/app.hook'
import { selectStrings } from '@app/slices/slice.app'

import { IDS } from '@doc/constants'
import { PatientKeys, PatientValues } from '@doc/type'
import { FormikProps } from 'formik'

interface ComponentProps {
    readOnly: boolean
    patientEditFormik: FormikProps<Pick<
    PatientValues, 'firstName' | 'lastName' | 'email' | 'patientNumber'> & {active: boolean}>
    handleKeyDown: (
        e: React.KeyboardEvent<HTMLInputElement | HTMLSelectElement>,
        fieldName?: PatientKeys
    ) => void
}

const PatientNumber = ({ readOnly, patientEditFormik, handleKeyDown }:ComponentProps) => {
    const strings = useAppSelector(selectStrings)
    const fieldName: PatientKeys = 'patientNumber'

    const result = <div className={'form-group'}>
        <div className={'row mt-3 align-items-center'}>
            <div className={'col-3 d-none d-sm-block'}>
                <label htmlFor={IDS.PATIENT.EDIT.PATIENT_NUMBER}
                    className={'form-label'}>{
                        strings.doc?.text.patient.add_interface
                            .steps['1'].fields.patient_number
                    }</label>
            </div>
            <div className={'col-sm-9 col-12'}>
                <input
                    readOnly={readOnly}
                    type={'text'}
                    name={fieldName}
                    className={[
                        'form-control-sm',
                        readOnly ? 'form-control-plaintext' : 'form-control',
                        patientEditFormik.errors.patientNumber &&
                         'border-danger'
                    ].join(' ')}
                    placeholder={!readOnly
                        ? strings.doc?.text.patient.add_interface
                            .steps['1'].fields.patient_number
                        : ''}
                    value={patientEditFormik.values.patientNumber}
                    id={IDS.PATIENT.EDIT.PATIENT_NUMBER}
                    onBlur={patientEditFormik.handleBlur}
                    onChange={!readOnly ? patientEditFormik.handleChange : () => {}}
                    onKeyDown={handleKeyDown}
                    required
                />
                <div className={'form-text error'}>{
                    patientEditFormik.errors.patientNumber
                        ? patientEditFormik.errors.patientNumber
                        : null
                }</div>
            </div>

        </div>

    </div>

    return result
}

export default PatientNumber
